import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";

export const useIsRealEstateClubId = () => {
    const { leadData } = useSelector((state: RootState) => state.lead);

    const isRealEstateClubId = useMemo(() => {
        const realEstateClubIds = [
            2, // prod
            120, // staging
            116 // dev
        ];
        const groupId = Number((leadData?.group as any)?.id);

        return realEstateClubIds.includes(groupId);
    }, [leadData?.group])

    return isRealEstateClubId
}